import React from "react"

import { AppIncExSelect } from "@components"
import { excludeWebSuppliers } from "@signals"


export default function AppCommonFiltersExcludeWebSuppliersSelect({ ...props }) {
	return <AppIncExSelect
		value={excludeWebSuppliers.value}
		onChange={e => excludeWebSuppliers.value = e.target.value}
		{...props}
	/>
}